import cubejs from '@cubejs-client/core';
import auth from '@/helpers/auth';

export function createCubeApi(apiUrl, options = {}) {
    const token = options.token;
    const url = apiUrl || process.env.VUE_APP_CUBEJS_API_URL;

    return cubejs(token, {
        apiUrl: url,
        ...options
    });
}

export function getCubeApi() {
    return createCubeApi();
}

export default {
    install(Vue, options = {}) {
        const cubeApi = createCubeApi(options.apiUrl, options);
        Vue.prototype.$cubeApi = cubeApi;
    }
};
